import { render, staticRenderFns } from "./Telethon.vue?vue&type=template&id=7f957f08&"
import script from "./Telethon.vue?vue&type=script&lang=js&"
export * from "./Telethon.vue?vue&type=script&lang=js&"
import style0 from "./Telethon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports